import script from "./activityDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./activityDetails.vue?vue&type=script&setup=true&lang=js"

import "./activityDetails.vue?vue&type=style&index=0&id=53f39140&lang=scss"

const __exports__ = script;

export default __exports__